import { useSelector } from "react-redux";
import * as S from "./selectors";

export const useIsImpersonating = () => useSelector(S.getIsImpersonating);

export const useImpersonatedUserName = () =>
  useSelector(S.getImpersonatedUserName);

export const useImpersonatedUserId = () =>
  useSelector(S.getImpersonatedUserId) ?? null;
